import React, { SVGAttributes } from 'react';

type SpecialsIconProps = SVGAttributes<unknown> & {
  isActive?: boolean;
};

export const SpecialsIcon = ({ isActive = false, ...props }: SpecialsIconProps): JSX.Element => {
  if (isActive) {
    return (
      <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' {...props}>
        <g clipPath='url(#clip0_4017_82586)'>
          <path
            d='M9.01758 0.744141C10.0281 0.744253 10.9981 1.14599 11.7129 1.86035L22.5518 12.6982L22.7109 12.875C23.0616 13.3031 23.2559 13.8421 23.2559 14.4004C23.2557 15.0382 23.0026 15.6505 22.5518 16.1016L16.1025 22.5508V22.5518C15.6515 23.0026 15.0391 23.2556 14.4014 23.2559C13.7634 23.2559 13.1504 23.0027 12.6992 22.5518V22.5508L1.86133 11.7119C1.14685 10.997 0.744124 10.0273 0.744141 9.0166V3.15039C0.744141 2.51221 0.998936 1.90048 1.4502 1.44922C1.90143 0.998112 2.51331 0.744141 3.15137 0.744141H9.01758ZM6.66602 5.25977C6.29323 5.25989 5.93548 5.40827 5.67188 5.67188C5.4083 5.93557 5.26074 6.29317 5.26074 6.66602C5.26074 7.03886 5.4083 7.39646 5.67188 7.66016C5.93548 7.92376 6.29323 8.07214 6.66602 8.07227C7.03898 8.07227 7.39741 7.92388 7.66113 7.66016C7.9247 7.39646 8.07227 7.03886 8.07227 6.66602C8.07227 6.29317 7.9247 5.93557 7.66113 5.67188C7.39741 5.40815 7.03898 5.25977 6.66602 5.25977Z'
            fill='#485055'
          />
        </g>
        <defs>
          <clipPath id='clip0_4017_82586'>
            <rect width='24' height='24' fill='white' />
          </clipPath>
        </defs>
      </svg>
    );
  }

  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' {...props}>
      <g clipPath='url(#clip0_3891_131656)'>
        <path
          d='M1.74463 3.15039V9.01633C1.74454 9.76205 2.04062 10.4773 2.56775 11.0048L13.4062 21.8441C13.6699 22.1078 14.0275 22.2559 14.4004 22.2559C14.7733 22.2559 15.1309 22.1078 15.3946 21.8441L21.8437 15.3941C22.1073 15.1304 22.2554 14.7728 22.2554 14.3999C22.2554 14.027 22.1073 13.6694 21.8437 13.4057L11.0053 2.56727C10.4778 2.04013 9.76254 1.74405 9.01682 1.74414H3.15088C2.77792 1.74414 2.42023 1.8923 2.15651 2.15602C1.89279 2.41974 1.74463 2.77743 1.74463 3.15039Z'
          stroke='#485055'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M5.26025 6.66602C5.26025 7.03898 5.40841 7.39666 5.67214 7.66038C5.93586 7.92411 6.29354 8.07227 6.6665 8.07227C7.03946 8.07227 7.39715 7.92411 7.66087 7.66038C7.9246 7.39666 8.07275 7.03898 8.07275 6.66602C8.07275 6.29305 7.9246 5.93537 7.66087 5.67165C7.39715 5.40792 7.03946 5.25977 6.6665 5.25977C6.29354 5.25977 5.93586 5.40792 5.67214 5.67165C5.40841 5.93537 5.26025 6.29305 5.26025 6.66602Z'
          stroke='#485055'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_3891_131656'>
          <rect width='24' height='24' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};
